import script from "./RecurringPaymentsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecurringPaymentsPage.vue?vue&type=script&setup=true&lang=ts"

import "./RecurringPaymentsPage.vue?vue&type=style&index=0&id=7cbac79e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cbac79e"]])

export default __exports__